import { NgModule } from '@angular/core';
import { ShopStoreModule } from './shop-store.module';

@NgModule({
  imports: [ShopStoreModule],
})
export class ShopDataAccessModule {}
